module.exports = __webpack_public_path__ + "static/media/kljp_logo.5235be0a.png";